export default __webpack_public_path__ + "static/media/opensans-lightitalic-webfont.8baa2e24.woff2";